import styled from '@emotion/styled';
import margins from '../utils/caluclateMargins';

export const Content = styled.div`
  width: 100%;
  height: 100%;
`;

export const AsideInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${margins}
`;

export const ImgContainer = styled.div`
  width: 100%;
  & .gatsby-image-wrapper {
    max-height: 250px;
  }
`;

export const LogoContainer = styled.div`
  max-width: 177px;
  ${margins}
`;

export const PostsContentContainer = styled.div`
  font-family: canada-type-gibson;
  font-style: normal;
  ${margins}
  color: ${({ theme, color }) => theme.colors[color] || theme.colors.gray3};
  a {
    color: ${({ theme, color }) => theme.colors[color] || theme.colors.gray3};
  }

  & > *:not(:first-child) {
    margin-top: ${({ theme }) => theme.spacings[4]};
  }
  strong {
    font-weight: 600;
  }

  & * {
    line-height: 1.5rem;
  }

  & ul {
    list-style: none;
    margin-left: 0;
    padding-left: 1.2rem;
    margin-top: 0.5rem !important;
  }
  & ul > li:before {
    display: inline-block;
    content: '-';
    width: 1em;
    margin-left: -1em;
  }
`;

export const CardContainer = styled.div`
  padding: 3.5rem 0 3.5rem 0.5rem;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  ${({ theme }) => theme.media.tablet} {
    border: none;
    padding: 0;
    margin-bottom: 30px;
  }
  ${({ theme }) => theme.media.mobile} {
    border: none;
    padding: 0;
    margin-bottom: 50px;
  }
`;

export const JobContent = styled.div`
  ${({ theme }) => theme.media.mobile} {
    margin-top: 2rem;
  }
`;

export const PostDesktopWrapper = styled.div`
  ${({ theme }) => theme.media.tablet} {
    display: none;
  }
`;

export const PostTabletAndMobileWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.media.tablet} {
    display: block;
  }
`;

export const PostTabletWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.media.tablet} {
    display: block;
  }

  ${({ theme }) => theme.media.mobile} {
    display: none;
  }
`;

export const PostMobileWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.media.mobile} {
    display: block;
  }
`;
